import React, { Component } from 'react'
import CircularProgress from 'material-ui/CircularProgress'

import * as Constants from '../../helpers/Constants'

class Button extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hover: false
    }
  }

  getStyle() {
    const { hover } = this.state
    const {
      marginTop = 10,
      marginRight = 0,
      marginLeft = 0,
      marginBottom = 0,
      className = 'outlined',
      color = className === 'outlined' ? 'transparent' : '#e9446a',
      hoverColor = className === 'outlined' ? 'white' : '#ff7998',
      width = 256,
      disabled,
      maxWidth,
      height = 40
    } = this.props
    const style = {
      height,
      width,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: hover ? hoverColor : color,
      borderRadius: 25,
      marginTop,
      marginRight,
      marginLeft,
      marginBottom,
      maxWidth
    }
    if (disabled) style.cursor = 'not-allowed'
    switch (className) {
      case 'primary':
        style.backgroundColor = hover ? hoverColor : color
        break
      case 'success':
        style.backgroundColor = hover
          ? Constants.WHITE_LABEL.colors.primaryHover
          : Constants.WHITE_LABEL.colors.primary
        break
      case 'warning':
        style.backgroundColor =
          hover && !disabled
            ? Constants.WHITE_LABEL.colors.warningHover
            : Constants.WHITE_LABEL.colors.warning
        break
      case 'passed':
        style.backgroundColor = hover ? hoverColor : color
        break
      case 'outlined':
        style.border = '2px solid white'
        break
      case 'filled':
        style.backgroundColor = hover ? hoverColor : color
        style.backgroundColor = disabled ? '#e0e0e0' : style.backgroundColor
        style.height = 46
        break
      default:
    }
    return style
  }

  getTextStyle() {
    const { hover } = this.state
    const { className = 'outlined' } = this.props
    const style = { fontWeight: '300', fontSize: 14, textAlign: 'center' }
    switch (className) {
      case 'outlined':
        style.color = hover ? '#3fa6c1' : 'white'
        break
      case 'filled':
        style.color = 'white'
        break
      default:
        style.color = hover ? '#fff' : '#fff'
    }
    return style
  }

  getText() {
    const { header, loading } = this.props
    if (loading) return <CircularProgress color={'white'} size={20} />
    return <p style={this.getTextStyle()}>{header.toUpperCase()}</p>
  }

  render() {
    const { onClick = () => {}, loading, cssClass } = this.props
    return (
      <a
        className={cssClass}
        style={this.getStyle()}
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => {
          if (!loading) onClick()
        }}
      >
        {this.getText()}
      </a>
    )
  }
}

export { Button }



// WEBPACK FOOTER //
// ./src/components/common/Button.js